import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { taxApi } from '@app/store';
import { ITax, TaxDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { TaxForm } from './TaxForm';
import { TaxFormValues } from './tax-form.helpers';
import { useToast, useTriptych, useUpdateCardData } from '@app/hooks';

const transformToUpdatableFormTax = (tax?: Partial<ITax>): TaxFormValues => {
  return {
    name: tax?.name,
    codeVAT: tax?.codeVAT,
    nameVAT: tax?.nameVAT,
    rate: tax?.rate,
    salesCodeHT: tax?.salesCodeHT,
    salesNameHT: tax?.salesNameHT
  }
}

interface TaxUpdateProps {
  tax?: ITax;
  isFetching?: boolean;
}

export const TaxUpdate = ({ tax, isFetching }: TaxUpdateProps) => {
  const toast = useToast();

  const triptych = useTriptych()

  const [update, { isLoading, error: apiErrors }] = taxApi.useUpdateOneTaxMutation();

  const formMethods = useForm<TaxFormValues>({
    resolver: classValidatorResolver(TaxDTO),
    defaultValues: transformToUpdatableFormTax(tax),
  });

  // @ts-ignore
  useUpdateCardData(formMethods, ['name']);

  useEffect(() => {
    formMethods.reset(transformToUpdatableFormTax(tax));
  }, [tax, formMethods.reset]);

  const onUpdate = async (formValues: TaxFormValues) => {

    console.log(formValues);

    try {
      const updatedTax = await update({ 
        _id: tax?._id,
        name: formValues.name,
        codeVAT: Number(formValues.codeVAT),
        nameVAT: formValues.nameVAT,
        rate: formValues.rate,
        salesCodeHT: Number(formValues.salesCodeHT),
        salesNameHT: formValues.salesNameHT
      }).unwrap();

      triptych.close({ mode: 'UPDATE', data: updatedTax });

      toast.success('Modification effectuée avec succès.')
    } catch {
      toast.error('Une erreur est survenue lors de la modification.')
    }
  }

  return (
    <Panel.Content>

      <Form isLoading={isFetching} formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.FormContainer>

          <TaxForm />

        </Panel.FormContainer>

        <Panel.Actions>
          <Button
            title="Retour"
            grow
            large
            bordered
            onPress={() => triptych.close()} />

          <Button
            loading={isLoading}
            onPress={formMethods.handleSubmit(onUpdate)}
            title="Valider"
            grow
            large />
        </Panel.Actions>

      </Form>

    </Panel.Content>
  );
};

